import { addRecord, addRecords } from '../helpers'
import * as types from '../mutation-types'

export default {
  state: {
    editor: {
      id: 0,
      is_visible: false,
      disabled: true
    },
    topology_blueprints: [],
    topology_categories: [],
    topology_groups: [],
    topology_images: [],
    topology_locations: []
  },

  mutations: {
    [types.SET_TOPOLOGY_EDITOR_ID] (state, id) {
      state.editor.id = id
      state.editor.disabled = false
      state.editor.is_visible = true
    },
    [types.SET_TOPOLOGY_BLUEPRINT_ATTRIBUTES] (state, data) {
      var topology_blueprint = state.topology_blueprints.find(
          t => t.id == state.editor.id
        )

      for (var name in data) {
        topology_blueprint.attributes[name] = data[name]
      }
    },
    [types.CLEAR_TOPOLOGY_RELATIONSHIPS] (state) {
      state.topology_categories = []
      state.topology_groups = []
      state.topology_images = []
    },
    [types.ADD_TOPOLOGY_BLUEPRINT] (state, topology_blueprint) {
      addRecord(state.topology_blueprints, topology_blueprint, 'topology_blueprints')
    },
    [types.ADD_TOPOLOGY_BLUEPRINTS] (state, topology_blueprints) {
      addRecords(state.topology_blueprints, topology_blueprints, 'topology_blueprints')
    },
    [types.ADD_TOPOLOGY_CATEGORY] (state, topology_categories) {
      addRecords(state.topology_categories, topology_categories, 'topology_categories')
    },
    [types.ADD_TOPOLOGY_GROUPS] (state, topology_groups) {
      addRecords(state.topology_groups, topology_groups, 'topology_groups')
    },
    [types.ADD_TOPOLOGY_IMAGES] (state, topology_images) {
      addRecords(state.topology_images, topology_images, 'topology_images')
    },
    [types.ADD_TOPOLOGY_LOCATIONS] (state, topology_locations) {
      addRecords(state.topology_locations, topology_locations, 'topology_locations')
    }
  },

  actions: {
    getTopologyBlueprint (context, payload) {
      axios.get('/api/me/topology_blueprints/' + payload.id)
        .then(function (response) {
          // success callback
          let blueprint = response.data
          // Add topology locations
          context.commit(types.ADD_TOPOLOGY_BLUEPRINT, blueprint.data)
          // Add included relationship data
          context.commit(types.CLEAR_TOPOLOGY_RELATIONSHIPS)
          context.commit(types.ADD_TOPOLOGY_CATEGORY, blueprint.included)
          context.commit(types.ADD_TOPOLOGY_GROUPS, blueprint.included)
          context.commit(types.ADD_TOPOLOGY_IMAGES, blueprint.included)
          context.commit(types.ADD_IMAGE_BLUEPRINTS, blueprint.included)
          context.commit(types.ADD_IMAGE_FLAVORS, blueprint.included)
          context.commit(types.ADD_IMAGE_SNAPSHOTS, blueprint.included)
          // Set the current topology blueprint
          context.commit(types.SET_TOPOLOGY_EDITOR_ID, blueprint.data.id)
        })
        .catch(function (error) {
          // error callback
          // Set the current topology blueprint
          context.commit(types.SET_TOPOLOGY_EDITOR_ID, 0)
        })
    },

    getTopologyLocations (context) {
      axios.get('/api/topology_locations')
        .then(function (response) {
          // success callback
          let locations = response.data
          // Add topology locations
          context.commit(types.ADD_TOPOLOGY_LOCATIONS, locations.data)
        })
        .catch(function (error) {
          // error callback
          console.log(response)
        })
    },

    patchTopologyBlueprint (context, payload) {
      context.commit(types.SET_TOPOLOGY_BLUEPRINT_ATTRIBUTES, payload.json)

      let url = '/api/me/topology_blueprints/' + payload.id

      axios.patch(url, payload.json)
        .then(function (response) {
          // success callback
        })
        .catch(function (error) {
          // error callback
          payload.self.getTopologyBlueprint(payload)
        })
    },

    patchTopologyWanPathCount (context, payload) {
      context.commit(types.SET_TOPOLOGY_BLUEPRINT_ATTRIBUTES, payload.json)

      let url = '/api/me/topology_blueprints/' + payload.id

      axios.patch(url, payload.json)
        .then(function (response) {
          // success callback
          payload.self.getTopologyBlueprint(payload)
        })
        .catch(function (error) {
          // error callback
          payload.self.getTopologyBlueprint(payload)
        })
    },

    patchTopologyLocation (context, payload) {
      context.commit(types.SET_TOPOLOGY_BLUEPRINT_ATTRIBUTES, payload.json)

      let url = '/api/me/topology_blueprints/' + payload.id +
        '/relationships/topology_location'

      axios.patch(url, payload.json)
        .then(function (response) {
          // success callback
          payload.self.getTopologyBlueprint(payload)
        })
        .catch(function (error) {
          // error callback
          payload.self.getTopologyBlueprint(payload)
        })
    },

    postTopologyGroup (context, payload) {
      let url = '/api/me/topology_blueprints/' + payload.id +
        '/relationships/topology_groups'

      axios.post(url, payload.json)
        .then(function (response) {
          // success callback
          payload.self.getTopologyBlueprint(payload)
        })
        .catch(function (error) {
          // error callback
          payload.self.getTopologyBlueprint(payload)
        })
    },

    patchTopologyImage (context, payload) {
      let url = '/api/me/topology_blueprints/' + payload.id +
        '/relationships/topology_images/' + payload.json.topology_image_id

      axios.patch(url, payload.json)
        .then(function (response) {
          // success callback
          payload.self.getTopologyBlueprint(payload)
        })
        .catch(function (error) {
          // error callback
          payload.self.getTopologyBlueprint(payload)
        })
    }
  }
}
